<template>
    <div class="csSwipeItem">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'csSwiperItem',
        data() {
            return {}
        }
    }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/swiper/src/swiperItem.vue